/**
 * Datos geográficos de Chile: regiones → provincias → comunas
 */
export const CHILE = {
    'Arica y Parinacota': {
        'Arica': ['Arica', 'Camarones'],
        'Parinacota': ['Putre', 'General Lagos'],
    },
    'Tarapacá': {
        'Iquique': ['Iquique', 'Alto Hospicio'],
        'El Tamarugal': ['Camiña', 'Colchane', 'Huara', 'Pica', 'Pozo Almonte'],
    },
    'Antofagasta': {
        'Antofagasta': ['Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal'],
        'El Loa': ['Calama', 'Ollagüe', 'San Pedro de Atacama'],
        'Tocopilla': ['María Elena', 'Tocopilla'],
    },
    'Atacama': {
        'Copiapó': ['Caldera', 'Copiapó', 'Tierra Amarilla'],
        'Chañaral': ['Chañaral', 'Diego de Almagro'],
        'Huasco': ['Alto del Carmen', 'Freirina', 'Huasco', 'Vallenar'],
    },
    'Coquimbo': {
        'Elqui': ['Andacollo', 'Coquimbo', 'La Higuera', 'La Serena', 'Paihuano', 'Vicuña'],
        'Choapa': ['Canela', 'Illapel', 'Los Vilos', 'Salamanca'],
        'Limarí': ['Combarbalá', 'Monte Patria', 'Ovalle', 'Punitaqui', 'Río Hurtado'],
    },
    'Valparaíso': {
        'Valparaíso': ['Casablanca', 'Concón', 'Juan Fernández', 'Puchuncaví', 'Quintero', 'Valparaíso', 'Viña del Mar'],
        'Isla de Pascua': ['Isla de Pascua'],
        'Los Andes': ['Calle Larga', 'Los Andes', 'Rinconada', 'San Esteban'],
        'Petorca': ['Cabildo', 'La Ligua', 'Papudo', 'Petorca', 'Zapallar'],
        'Quillota': ['Calera', 'Hijuelas', 'La Cruz', 'Nogales', 'Quillota'],
        'San Antonio': ['Algarrobo', 'Cartagena', 'El Quisco', 'El Tabo', 'San Antonio', 'Santo Domingo'],
        'San Felipe de Aconcagua': ['Catemu', 'Llaillay', 'Panquehue', 'Putaendo', 'San Felipe', 'Santa María'],
        'Marga Marga': ['Limache', 'Olmué', 'Quilpué', 'Villa Alemana'],
    },
    'Metropolitana de Santiago': {
        'Santiago': ['Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón', 'Santiago', 'Vitacura'],
        'Chacabuco': ['Colina', 'Lampa', 'Til Til'],
        'Cordillera': ['Pirque', 'Puente Alto', 'San José de Maipo'],
        'Maipo': ['Buin', 'Calera de Tango', 'Paine', 'San Bernardo'],
        'Melipilla': ['Alhué', 'Curacaví', 'María Pinto', 'Melipilla', 'San Pedro'],
        'Talagante': ['El Monte', 'Isla de Maipo', 'Padre Hurtado', 'Peñaflor', 'Talagante'],
    },
    "O'Higgins": {
        'Cachapoal': ['Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'Las Cabras', 'Machalí', 'Malloa', 'Mostazal', 'Olivar', 'Peumo', 'Pichidegua', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa', 'San Vicente'],
        'Colchagua': ['Chépica', 'Chimbarongo', 'Lolol', 'Nancagua', 'Palmilla', 'Peralillo', 'Placilla', 'Pumanque', 'San Fernando', 'Santa Cruz'],
        'Cardenal Caro': ['La Estrella', 'Litueche', 'Marchihue', 'Navidad', 'Paredones', 'Pichilemu'],
    },
    'Maule': {
        'Talca': ['Constitución', 'Curepto', 'Empedrado', 'Maule', 'Pelarco', 'Pencahue', 'Río Claro', 'San Clemente', 'San Rafael', 'Talca'],
        'Curicó': ['Curicó', 'Hualañé', 'Licantén', 'Molina', 'Rauco', 'Romeral', 'Sagrada Familia', 'Teno', 'Vichuquén'],
        'Linares': ['Colbún', 'Linares', 'Longaví', 'Parral', 'Retiro', 'San Javier', 'Villa Alegre', 'Yerbas Buenas'],
        'Cauquenes': ['Cauquenes', 'Chanco', 'Pelluhue'],
    },
    'Ñuble': {
        'Diguillín': ['Bulnes', 'Chillán', 'Chillán Viejo', 'El Carmen', 'Pemuco', 'Pinto', 'Quillón', 'San Ignacio', 'Yungay'],
        'Itata': ['Cobquecura', 'Coelemu', 'Ninhue', 'Portezuelo', 'Quirihue', 'Ránquil', 'Trehuaco'],
        'Punilla': ['Coihueco', 'Ñiquén', 'San Carlos', 'San Fabián', 'San Nicolás'],
    },
    'Biobío': {
        'Concepción': ['Chiguayante', 'Concepción', 'Coronel', 'Florida', 'Hualpén', 'Hualqui', 'Lota', 'Penco', 'San Pedro de la Paz', 'Santa Juana', 'Talcahuano', 'Tomé'],
        'Arauco': ['Arauco', 'Cañete', 'Contulmo', 'Curanilahue', 'Lebu', 'Los Álamos', 'Tirúa'],
        'Biobío': ['Alto Biobío', 'Antuco', 'Cabrero', 'Laja', 'Los Ángeles', 'Mulchén', 'Nacimiento', 'Negrete', 'Quilaco', 'Quilleco', 'San Rosendo', 'Santa Bárbara', 'Tucapel', 'Yumbel'],
    },
    'La Araucanía': {
        'Cautín': ['Carahue', 'Cholchol', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica'],
        'Malleco': ['Angol', 'Collipulli', 'Curacautín', 'Ercilla', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Purén', 'Renaico', 'Traiguén', 'Victoria'],
    },
    'Los Ríos': {
        'Valdivia': ['Corral', 'Futrono', 'La Unión', 'Lago Ranco', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia'],
        'Ranco': ['Futrono', 'La Unión', 'Lago Ranco', 'Río Bueno'],
    },
    'Los Lagos': {
        'Llanquihue': ['Calbuco', 'Cochamó', 'Fresia', 'Frutillar', 'Llanquihue', 'Los Muermos', 'Maullín', 'Puerto Montt'],
        'Chiloé': ['Ancud', 'Castro', 'Chonchi', 'Curaco de Vélez', 'Dalcahue', 'Puqueldón', 'Queilén', 'Quemchi', 'Quellón', 'Quinchao'],
        'Osorno': ['Osorno', 'Puerto Octay', 'Purranque', 'Puyehue', 'Río Negro', 'San Juan de la Costa', 'San Pablo'],
        'Palena': ['Chaitén', 'Futaleufú', 'Hualaihué', 'Palena'],
    },
    'Aysén': {
        'Coyhaique': ['Coyhaique', 'Lago Verde'],
        'Aysén': ['Aysén', 'Cisnes', 'Guaitecas'],
        'Capitán Prat': ['Cochrane', 'O\'Higgins', 'Tortel'],
        'General Carrera': ['Chile Chico', 'Río Ibáñez'],
    },
    'Magallanes y la Antártica Chilena': {
        'Magallanes': ['Laguna Blanca', 'Punta Arenas', 'Río Verde', 'San Gregorio'],
        'Antártica Chilena': ['Cabo de Hornos', 'Antártica'],
        'Tierra del Fuego': ['Porvenir', 'Primavera', 'Timaukel'],
        'Última Esperanza': ['Natales', 'Torres del Paine'],
    },
};

export const REGIONES = Object.keys(CHILE);

/**
 * Dado una región, devuelve array de {provincia, comuna}
 */
export function getComunas(region) {
    if (!region || !CHILE[region]) return [];
    const result = [];
    for (const [provincia, comunas] of Object.entries(CHILE[region])) {
        for (const comuna of comunas) {
            result.push({ provincia, comuna });
        }
    }
    return result;
}

/**
 * Dado una región y una comuna, devuelve la provincia correspondiente
 */
export function getProvincia(region, comuna) {
    if (!region || !CHILE[region]) return '';
    for (const [provincia, comunas] of Object.entries(CHILE[region])) {
        if (comunas.includes(comuna)) return provincia;
    }
    return '';
}
